<script lang="ts">
  /**
   * "This is gone from Skool" — the one way this product says it.
   *
   * WHY IT IS SHOWN AT ALL, rather than the row being dropped. A deleted post or
   * comment is still work: it is why a queue row exists, and hiding it would turn
   * "answer this" into a card that silently is not there any more, with nothing to
   * tell the reader whether they dealt with it or the system lost it. Showing it and
   * SAYING what happened is the honest version — they can clear it knowing why.
   *
   * WHY A BADGE AND A TINT, and not one or the other. The tint is what makes the state
   * legible while scrolling a long thread, where a small chip reads as decoration; the
   * badge is what makes it unambiguous, because a red wash could equally mean an error
   * or a flag. `title` carries the sentence neither can — hover is the right place for
   * an explanation nobody needs twice.
   *
   * Its own component because the same fact is rendered on a post and on a comment, and
   * the two files already share nothing else. One definition is what stops the wording
   * drifting between them, which is the failure mode this package exists to prevent.
   */
  let {
    /** What is gone, so the hover reads naturally in both places. */
    kind = 'post',
    /** How this was learned. Only the Helper can see Skool directly, so the dashboard's
     *  copy has to be vaguer — it is repeating what the mirror was told. */
    detail = null,
  }: {
    kind?: 'post' | 'comment';
    detail?: string | null;
  } = $props();

  const title = $derived(
    detail ??
      `This ${kind} no longer exists on Skool — it was deleted after we mirrored it. ` +
        `You can still clear it from the queue.`,
  );
</script>

<span
  class="inline-flex shrink-0 items-center gap-1 rounded-full bg-error/15 px-1.5 py-0.5 text-[0.62rem] font-semibold uppercase leading-none tracking-wide text-error"
  {title}
>
  <svg
    class="h-2.5 w-2.5"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2.5"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  ><path d="M3 6h18" /><path d="M8 6V4h8v2" /><path d="M19 6l-1 14H6L5 6" /></svg>
  Deleted
</span>
